import { Link } from 'wouter';
import {
  LayoutDashboard,
  Users,
  Gift,
  DollarSign,
  Layers,
  ScrollText,
  Zap,
  LogOut,
  Handshake,
} from 'lucide-react';

interface SidebarProps {
  currentPath: string;
  walletAddress: string;
  onLogout: () => void | Promise<void>;
}

const navItems = [
  { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { path: '/users', icon: Users, label: 'Users' },
  { path: '/referrals', icon: Gift, label: 'Referrals' },
  { path: '/partners', icon: Handshake, label: 'Partners' },
  { path: '/payouts', icon: DollarSign, label: 'Payouts' },
  { path: '/fee-tiers', icon: Layers, label: 'Fee Tiers' },
  { path: '/jobs', icon: Zap, label: 'Jobs' },
  { path: '/audit-log', icon: ScrollText, label: 'Audit Log' },
];

export default function Sidebar({ currentPath, walletAddress, onLogout }: SidebarProps) {
  return (
    <aside className="w-56 min-h-screen border-r border-white/10 flex flex-col">
      {/* Logo */}
      <div className="p-4 border-b border-white/10">
        <div className="flex items-center gap-2">
          <img src="/favicon.png" alt="Proteus" className="w-5 h-5" />
          <span className="font-medium text-white">Proteus Admin</span>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-2">
        {navItems.map((item) => {
          const isActive = currentPath === item.path;
          const Icon = item.icon;

          return (
            <Link key={item.path} href={item.path}>
              <a
                className={`flex items-center gap-3 px-3 py-2 text-sm transition-colors ${
                  isActive
                    ? 'bg-emerald-500/10 text-emerald-400 border-l-2 border-emerald-500'
                    : 'text-zinc-400 hover:text-white hover:bg-white/5'
                }`}
              >
                <Icon className="w-4 h-4" />
                {item.label}
              </a>
            </Link>
          );
        })}
      </nav>

      {/* User Section */}
      <div className="p-3 border-t border-white/10">
        <div className="text-xs text-zinc-500 mb-2">Connected as</div>
        <div className="text-xs font-mono text-zinc-300 mb-3 truncate">
          {walletAddress.slice(0, 6)}...{walletAddress.slice(-4)}
        </div>
        <button
          onClick={onLogout}
          className="w-full flex items-center justify-center gap-2 px-3 py-2 text-xs
            text-zinc-400 hover:text-red-400 border border-white/10 hover:border-red-500/30
            hover:bg-red-500/10 transition-colors"
        >
          <LogOut className="w-3 h-3" />
          Disconnect
        </button>
      </div>
    </aside>
  );
}
